import axios from 'axios'
import { toSnakeCase } from 'src/helpers/objectUtils'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(
  async (request) => {
      const token = localStorage.getItem('USER_TOKEN')
    if (token) {
      request.headers['Auth-Token'] = token
    } else {
      delete request.headers['Auth-Token']
    }
    // `vars` is a key->value map (var1..var15) whose keys are meaningful
    // identifiers, not field names - snakeCase('var1') === 'var_1' would
    // otherwise silently break {{varN}} substitution on the backend.
    request.data = toSnakeCase(request.data, ['base64_file'], ['vars'])
    request.params = toSnakeCase(request.params, ['base64_file'], ['vars'])

    return request
  },
  (errData) => {
    return errData
  },
)

axiosInstance.interceptors.response.use(
  (response) => {
    return response
  },
  (errData) => {
    const status = errData?.response?.status
    const path = window.location.pathname

    const isPublicPage =
      path.startsWith('/qrdownload') ||
      path === '/login' ||
      path === '/register'

    if (status === 401 && !isPublicPage) {
      window.location.href = '/login'
    }

    return Promise.reject(errData)
  },
)

export { axiosInstance }
